import { createRouter, createWebHashHistory } from "vue-router";
const router = createRouter({
    history: createWebHashHistory('/'), // 这里指定基本URL
    routes: [
        {
            path: "/",
            redirect: "/home",
        },
        {
            path: '/home',
            name: 'Home',
            component: () => import('@/views/home/index.vue')
        },
        {
            path: '/about',
            name: 'About',
            component: () => import('@/views/about/about.vue')
        },
    ]
})
export default router